module.exports = __webpack_public_path__ + "img/29.35f6039a.jpeg";